<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员内容设置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row>
        <el-col :span="24">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="报名须知">
              <el-input
                type="textarea"
                v-model="form.RegInstructions"
                rows="6"
              ></el-input>
            </el-form-item>
            <el-form-item label="作品要求">
              <el-input
                type="textarea"
                v-model="form.WorkRequirements"
                rows="6"
              ></el-input>
            </el-form-item>
            <el-form-item label="温馨提示">
              <el-input
                type="textarea"
                v-model="form.Reminder"
                rows="6"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        RegInstructions: '',
        WorkRequirements: '',
        Reminder: ''
      }
    }
  },
  created() {
    this.getReviewSettings()
  },
  methods: {
    // 回填写会员内容设置
    async getReviewSettings() {
      const { data: res } = await this.$http.get('/api/MemberContent/GetMemberContent')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.form = res.Data.memberContent
    },
    // 保存会员内容设置
    async onSubmit() {
      const { data: res } = await this.$http.post(
        '/api/MemberContent/SaveMemberContent',
        this.form
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.$message.success(res.Msg)
      this.getReviewSettings()
    }
  }
}
</script>
<style lang="less" scoped>
</style>
